var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{directives:[{name:"resize",rawName:"v-resize",value:(_vm.onResize),expression:"onResize"}]},[_c('v-main',[_c('v-fade-transition',{attrs:{"leave-absolute":""}},[_c('router-view')],1)],1),_c('video-call-viewer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }